import { render, staticRenderFns } from "./DetalleReserva.vue?vue&type=template&id=e2009d5e&"
import script from "./DetalleReserva.vue?vue&type=script&lang=js&"
export * from "./DetalleReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports